<template>
    <div
        class="absolute left-1/2 top-14 z-50 flex -translate-x-1/2 items-center justify-center"
        aria-label="Progress"
    >
        <div
            class="h-2 w-52 overflow-hidden rounded-full bg-white ring-1 ring-royal"
        >
            <div
                class="tranistion-[width] h-full rounded-full bg-yellow duration-300 ease-out"
                :style="{ width: `${percent}%` }"
            ></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
    current: number;
    total: number;
}>();

const percent = computed(() => {
    if (!props.total) return 0;
    return Math.max(0, Math.min(100, (props.current / props.total) * 100));
});
</script>

<style scoped></style>
